import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { name: IconName };

export type IconName =
  | 'shield' | 'lock' | 'bolt' | 'globe' | 'arrow-right' | 'arrow-up-right'
  | 'check' | 'menu' | 'close' | 'chevron-down' | 'clock' | 'layers'
  | 'feather' | 'key' | 'eye' | 'send' | 'twitter' | 'telegram' | 'mail'
  | 'swap' | 'star' | 'sparkles' | 'gas' | 'wallet' | 'chart';

const paths: Record<IconName, React.ReactNode> = {
  shield: <path d="M12 2 4 6v6c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6l-8-4z" />,
  lock: (
    <>
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </>
  ),
  bolt: <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />,
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.5 4 5.7 4 9s-1.5 6.5-4 9c-2.5-2.5-4-5.7-4-9s1.5-6.5 4-9z" />
    </>
  ),
  'arrow-right': <path d="M5 12h14M13 5l7 7-7 7" />,
  'arrow-up-right': <path d="M7 17 17 7M8 7h9v9" />,
  check: <path d="M20 6 9 17l-5-5" />,
  menu: <path d="M3 6h18M3 12h18M3 18h18" />,
  close: <path d="M18 6 6 18M6 6l12 12" />,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  layers: <path d="m12 2 9 5-9 5-9-5 9-5zM3 12l9 5 9-5M3 17l9 5 9-5" />,
  feather: (
    <>
      <path d="M20.2 3.8a5.5 5.5 0 0 0-7.8 0L4 12.2V20h7.8l8.4-8.4a5.5 5.5 0 0 0 0-7.8z" />
      <path d="M16 8 4 20M14 8H8v6" />
    </>
  ),
  key: (
    <>
      <circle cx="8" cy="8" r="5" />
      <path d="m11 11 9 9M16 16l2-2M19 19l2-2" />
    </>
  ),
  eye: (
    <>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  send: <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" />,
  twitter: <path d="M22 5.8c-.7.3-1.5.5-2.3.6.8-.5 1.4-1.3 1.7-2.2-.8.5-1.6.8-2.5 1a4 4 0 0 0-6.8 3.6A11.3 11.3 0 0 1 3.9 4.5a4 4 0 0 0 1.2 5.3c-.6 0-1.2-.2-1.8-.5a4 4 0 0 0 3.2 4 4 4 0 0 1-1.8.1 4 4 0 0 0 3.7 2.8A8 8 0 0 1 2 18.6a11.3 11.3 0 0 0 6.1 1.8c7.4 0 11.4-6.1 11.4-11.4v-.5c.8-.6 1.5-1.3 2-2.1z" />,
  telegram: <path d="M21.9 4.3 2.6 11.7c-1 .4-1 1.8 0 2.1l4.8 1.6 1.8 5.8c.3.8 1.3 1 1.9.4l2.7-2.5 5 3.7c.7.5 1.7.1 1.9-.7L23.9 5.5c.2-1-.7-1.8-1.6-1.4z" />,
  mail: (
    <>
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m2 6 10 7L22 6" />
    </>
  ),
  swap: <path d="M7 4 3 8l4 4M3 8h14M17 20l4-4-4-4M21 16H7" />,
  star: <path d="m12 2 3 7 7 .6-5.3 4.7L18 22l-6-4-6 4 1.3-7.7L2 9.6 9 9z" />,
  sparkles: <path d="m12 3 1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5zM19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8zM5 14l.8 2.2L8 17l-2.2.8L5 20l-.8-2.2L2 17l2.2-.8z" />,
  gas: <path d="M18 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h0a3 3 0 0 0 3-3V6M3 21V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v16M3 9h11M3 15h11" />,
  wallet: (
    <>
      <path d="M3 7a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v3" />
      <path d="M3 7v10a2 2 0 0 0 2 2h14a1 1 0 0 0 1-1v-3" />
      <path d="M22 13h-5a2 2 0 0 1 0-4h5z" />
    </>
  ),
  chart: <path d="M3 3v18h18M7 14l3-3 3 3 5-6" />,
};

const fillIcons: Partial<Record<IconName, boolean>> = {
  bolt: true, star: true, sparkles: true, twitter: true, telegram: true,
};

export function Icon({ name, ...props }: IconProps) {
  const filled = fillIcons[name];
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
